module.exports = __webpack_public_path__ + "static/media/new-hire-onboarding-logo.fca34ee8.svg";